export default {
  // common erros
  ERROR: 'Something went wrong !',
  ERROR_LOADING_DATA: 'Error loading data from API. Please try again later.',
  NO_PERMISSION:
    'You do not have permission to perform this action. Please contact your administrator.',
  FILL_FIELDS: 'Please fill all the required fields.',
  UPDATE_SUCCESS: 'Updated successfully.',
  DOWNLOAD_SUCCESS: 'Downloaded successfully',
  // prefix a field name to these
  CANNOT_BE_EMPTY: ' cannot be empty',
  NO_RESULTS: 'No results found',
  NO_SEARCH_RESULTS: 'No results found. Try changing your search filters.',
  // suffix a field name
  SELECT_FIELD: 'Please select ',
  NO_PREVIEW: 'No comparable preview for this log',
  // cannot load X
  CANNOT_LOAD: 'Cannot load ',
  CANNOT_GET_PERMISSIONS: 'Could not get user permissions.',
  SESSION_EXPIRED:
    'Your session has expired. You will now be redirected to the login page.',
  SELECT_VALUE: 'Please select a value',
  INVALID_EMAIL1: 'Please enter a valid email address',
  INVALID_EMAIL2: 'Email is not vaild',
  DATE_RANGE_START: 'Start date should be less than end date',
  DATE_RANGE_END: 'End date should be greater than start date',
  SELECT_COLLAB: 'Select at least one collaborator to save',
  COLLAB_ADDED: 'New collaborator(s) added',
  COLLAB_REMOVED: 'Collaborator removed',
  SELECT_ITEMS: 'Select one or more items.',
  // Discovery
  ITEMS_SAVED: 'Selected items added to saved items.',
  ITEMS_REMOVED: 'Selected items removed from saved items.',
  ARCHIVE_LOADING_ERR: 'Error loading archives',
  // Comments related
  COMMENT_EMPTY: 'Comment cannot be empty',
  COMMENT_ADDED: 'Comment Added',
  CANNOT_ADD_COMMENT: 'Cannot add comment',
  COMMENT_RESOLVED: 'Comment resolved',
  COMMENT_REPLY_EMPTY: 'Comment reply cannot be empty.',
  COMMENT_REPLIED: 'Replied successfully.',
  COMMENT_EDITED: 'Edited successfully.',
  TAG_EMPTY: 'Tag cannot be empty',
  TAG_NOT_ALLOWED:
    'Its mandatory field and only alpha-numeric in lower case separated by hyphen/underscore allowed.',
  TAG_ADDED: 'Tag Added',
  // Archive details
  SELECT_CONTENT: 'Please select content to proceed.',
  OVERLAPPING_SELECTION:
    'Selection cannot overlap an existing comment or tag. Please make another selection',
  NO_PROJECT_ARCHIVE:
    'The desired project has zero archives, please change your search terms to have at least one Archive.',
  PROJECT_NO_SAVED_ITEMS:
    'There is no saved item with the project to show details',
  NO_ARCHIVE_EXPORT: 'This project does not have any saved archives to export.',
  PROJECT_ARCHIVED: 'Project has been archived.',
  PROJECT_CREATED: 'Project has been created.',
  NO_ARCHIVES: 'No archives found',
  CANNOT_CHANGE_PASSWORD: 'Cannot change password. Please try agin later.',
  GENERATE_PASSWORD: 'Generate Password',
  ROLE_ERROR: 'Error creating role.',
  ROLE_ADDED: 'Added successfully.',
  FIELDS_RESET: 'Fields has been reset!',
  ROLE_EMPTY: 'Role name cannot be empty',
  ROLE_NAME_RULE: 'Role name can only contain A-Z, a-z, -,_',
  LOG_SEARCH_ERROR: 'Error searching logs.',
  ADD_PERMISSION_RULE: 'Minimum 1 permission is required',
  NO_ORG: 'No organizations found.',
  ORG_ADD_ERROR: 'Error creating organization. Please try again later',
  TRY_AGAIN: 'Please try agin later.',
  ACCOUNT_ADD_ERROR: 'Error creating account.',
  ACCOUNT_ADDED: 'New account created.',
  // Audit trails
  CANT_LOAD_USERS: 'Cannot load users.',
  CANT_LOAD_SOURCE: 'Cannot load sources.',
  CANT_LOAD_EVENTS: 'Cannot load event types.',
  // Account
  ACCOUNT_CREATE_ERROR: 'Error creating account.',
  ACCOUNT_CREATED: 'New account created.',
  KPI_NOT_FOUND: 'Cannot find related KPI.',
  ERROR_DOWNLOADING_FILE: 'An error occured while downloading the file.',
  // EMAIL related
  MAIL_REDELIVERED: 'Email redelivered',
  MAIL_MARKED_SPAM: 'Email marked as Spam',
  MAIL_MOVED_INBOX: 'Email moved to Inbox',
  ADDED_SUCCESS: 'Added successfully',
  SAVED_SUCCESS: 'Saved successfully',
  EMAIL_EMPTY: 'Email cannot be empty',
  DOMAIN_EMPTY: 'Domain cannot be empty',
  SUBSCRIBER_ADDRESS_EMPTY: 'Subscriber Address cannot be empty',
  EMAIL_ADDED_SUCCESS: 'Email added successfully',
  DOMAIN_ADDED_SUCCESS: 'Domain added successfully',
  DOMAIN_REMOVED_SUCCESS: 'Domain removed successfully',
  // eslint-disable-next-line
  DOMAIN_NOT_MATCH: "Domain doesn't match",
  CANNOT_LOAD_SETTING_DATA: 'Cannot load setting data',
  INVALID_IP: 'Please enter a valid IP address',
  INVALID_IP_OR_DOMAIN: 'Please enter a valid IP address or Domain',
  IP_EMPTY: 'IP Address cannot be empty',
  VALUE_EMPTY: 'Value cannot be empty',
  NOT_AUTHORIZED: 'you are not authorized to do so.',
  IP_REMOVED_SUCCESS: 'IP Address removed successfully',
  IP_ADD_SUCCESS: 'IP Address added successfully',
  VALUE_NON_ZERO: 'Value should be more than zero',
  PASSWORD_CARE_HANDLE:
    'Please note down the password safely. It will not be displayed again.',
  // Permissions
  // eslint-disable-next-line
  NO_CONTENT_VIEW_PERMISSION: `Can't load preview as you don't have permission to view this content.`,
  // eslint-disable-next-line
  NO_PAGE_VIEW_PERMISSION: `Redirecting you one step back as you don't have permission to view this page.`,

  CANCELLED: 'CANCELLED',
  // Vault
  QUEUED: 'Successfully queued',
  EXPORT_QUEUED: driveName =>
    `The export process has started. When it is finished, you will find the exported files in a folder called 'XiftExport' in your ${
      driveName === 'Dropbox' ? 'organization' : 'personal'
    } ${driveName}`,

  ONBOARDING_STARTED:
    // eslint-disable-next-line
    'Thanks for completing the account setup. Your data is now syncing to Xift and we will notify you when it is ready to view.',
  ONBOARDING_COMPLETED:
    'Thank you for your patience. The sync has completed and your data is ready to view.',
  ONBOARDING_FAILED:
    'We’re very sorry, the sync has failed. Please contact our support team here and we’ll investigate and fix it.',
  ACTION_RESTRICTION_WHILE_ONBOARDING:
    'Onboarding is in process, you can do this action after it will complete.',
  NEW_CARD_ADDED: 'New card is added successfully!',
  DOWNLOADING_FILE_TAKING_TIME:
    'The download of this file(s) is taking longer than expected. We recommend trying to export the file(s) instead.',
  SSO_CALLBACK_MESSAGE: {
    sso: {
      success: 'You have enabled SSO for Xift from Office 365',
      failure: ''
    },
    o365_onedrive: {
      success: 'You have successfully connected OneDrive',
      failure: ''
    },
    o365_group: {
      success:
        'You have granted access for Xift to authenticate and query users from your domain',
      failure: ''
    },
    o365_sharepoint: {
      success: 'You have successfully connected SharePoint',
      failure: ''
    },
    o365_email: {
      success: 'You have granted access to email synchronization',
      failure: ''
    },
    ediscovery_project_export: {
      success: 'You have granted access for file Export/Restore to OneDrive',
      failure: ''
    },
    o365_teams: {
      success: 'You have successfully connected Teams',
      failure: ''
    },
    export_to_dropbox: {
      success: 'You have granted access for file Export/Restore to Dropbox',
      failure: ''
    },
    dropbox: {
      success: 'You have successfully connected Dropbox',
      failure: ''
    }
  },
  GET_TRIAL_WILL_EXPIRE_NOTIFICATION: remainingPeriod =>
    `Your trial pack will expire ${remainingPeriod}`,
  TRIAL_EXPIRED_NOTIFICATION: 'Your trial pack has expired',
  // Billing and Plans
  PAYMENT_METHOD_LIMIT_EXCEEDS: 'You cannot add more than 10 payment methods',
  SAME_PLAN_UPGRADE_ERROR:
    'You have already subscribed to this plan, please choose any other.',
  SEARCH_HISTORY: {
    PARSING_ERROR: 'Unable to show data, Please try after some time.'
  },
  TECHNICAL_ERROR:
    'Oops, we’re sorry but something didn’t work. Please try again and if it persists contact our support.',
  BILLING_MESSAGE: {
    NO_PLAN_CHOOSED: 'Please choose a plan first to upgrade',
    UPDATED_ADDONS: 'You have updated Add-Ons successfully',
    CHANGED_PLAN: 'You have changed your plan successfully',
    CHANGED_PLAN_AND_ADDONS:
      'You have changed your plan and updated Add-Ons successfully'
  },
  CONNECTOR_MESSAGE: {
    SYNC_STARTED: connector => `${connector} sync Started`,
    DISCONNECTED: connector => `${connector} disconnected`,
    INTEGRATION_SETTINGS_UPDATED: connector =>
      `${connector} integration settings updated`,
    NOT_VERIFIED:
      'A new connector is being created for your organisation, as it takes a bit of time for Microsoft to verify the connector it may appear as "Unverified". Please continue with this process and the verification will be completed in the background.'
  },
  EXPORT: {
    NO_PERMISSION: connectorName =>
      `In order to perform this action, it is necessary to enable the '${connectorName}' connector for your organization. If you do not have administrative privileges, kindly reach out to your organization's administrator for assistance.`,
    SUCCESS: 'Export started'
  },
  DISPLAY_MESSAGE_FOR_EMPTY_REPLY_MESSAGE: '~ No content to display ~',
  DISPLAY_MESSAGE_FOR_UNSUPPORTED_MESSAGE_ATTACHMENTS:
    '~ This media type is not supported on our platform ~',
  SUGGESTION_TO_ENABLE_ONEDRIVE:
    'You have enabled the Teams Connector, but your OneDrive Connector is disabled. For a better experience, please enable your OneDrive Connector as well.',
  DO_NOT_DISCONNECT_ONEDRIVE_ALERT:
    'To ensure a seamless user experience with Teams, we kindly request you to refrain from turning off Office 365 - OneDrive.'
};
